var polylang_controller = {
	updateLanguageSwitcherUrls: function () {
		updateLanguageSwitcherUrls()
	},
	i: function () {
		i()
	},
}

var i = function () {
	if (layData.is_polylang_active == 1) {
		window.laytheme.on('newpageshown', updateLanguageSwitcherUrls)
	}
}

var updateLanguageSwitcherUrls = function () {
	if (layData.is_polylang_active == 1) {
		jQuery.ajax({
			url: layData.wpapiroot + 'laytheme/v1/get_polylang_langswitcher_urls/',
			data: { id: jQuery('body').attr('data-id'), type: jQuery('body').attr('data-type') },
			method: 'GET',
			success: function (data) {
				var result = JSON.parse(data)
				if (Array.isArray(result)) {
					for (var i = 0; i < result.length; i++) {
						// result[i][0] is href
						// result[i][1] is language code

						if (typeof result[i][0] === 'string') {
							jQuery('.lang-item-' + result[i][1] + ' a').each(function () {
								// for language switcher in menu or in shortcode
								jQuery(this).attr('href', result[i][0])
							})
						}
					}
				}
			},
		})
	}
}

export default polylang_controller
